import * as React from "react";
import Button from "@ebsco-ui/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import cn from "classnames";
import { createBemBlockBuilder } from "@ebsco-ui/utils";

export interface DataTableToggleProps {
  className?: string;
  open: boolean;
  onClick?: () => void;
  [key: string]: any;
}

const DataTableToggle: React.FC<DataTableToggleProps> = ({
  className,
  open = false,
  id,
  onClick,
  ...props
}) => {
  const getBlocksWith = createBemBlockBuilder(["eb-data-table", className]);
  const defaultTitle = open ? "Collapse" : "Expand";

  return (
    <Button
      aria-label={props.ariaLabel}
      aria-describedby={props.ariaDescribedBy}
      aria-controls={`result${id}`}
      aria-expanded={open ? true : false}
      className={cn(
        getBlocksWith("__toggle-btn"),
        open
          ? getBlocksWith("__toggle-btn--is-open")
          : getBlocksWith("__toggle-btn--is-closed"),
      )}
      onClick={onClick}
      styleType="flat-icon"
    >
      <FontAwesomeIcon
        size="2x"
        icon={faAngleDown}
        title={props.title || defaultTitle}
        data-auto="toggle-icon"
      />
    </Button>
  );
};

export default DataTableToggle;
